"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeAnalytics = void 0;
var _reactGa = _interopRequireDefault(require("react-ga4"));
/**
 * Initializes Google Analytics 4 (GA4) using the Google Analytics Measurement ID from env variables.
 * It sets up GA4 only if the application is running in the staging or production environment.
 * Staging and production environments will have their own unique Measurement ID.
 */

const initializeAnalytics = brand => {
  const env = process.env.REACT_APP_ENV;
  const gaMeasurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!gaMeasurementId) {
    console.warn('REACT_APP_GA_MEASUREMENT_ID is not set. Google Analytics will not be initialized.');
    return;
  }
  if (env === "staging" || env === "production") {
    _reactGa.default.initialize(gaMeasurementId, {
      // Use gaOptions to send custom dimensions with every GA event except initial_page_view.
      // gtagOptions could be used to send custom dimensions to initial_page_view only, if desired.
      gaOptions: {
        // custom dimensions to report
        scripps_brand: brand,
        scripps_platform: 'Web'
      }
    });
  }
};
exports.initializeAnalytics = initializeAnalytics;